<template>
	<div class="home">
		<div class="home1">
			<div class="my-home1">
				<template>
					<div class="home-home1-content3">
						<Carousel autoplay :autoplay-speed="5000">
							<CarouselItem>
								<div class="demo-carousel">
									<img src="../assets/img/home1-bg3-content.png" width="100%"
										style="margin-top: -1rem;" />
									<a href="#twoPage">
										<div style="margin-top: -0.7rem;">
											<Arrow />
										</div>
									</a>
								</div>
							</CarouselItem>
							<CarouselItem>
								<div class="demo-carousel">
									<img src="../assets/img/home1-bg5-content.png" width="100%"
										style="margin-top: -1rem;" />
									<a href="#twoPage">
										<div style="margin-top: -0.7rem;">
											<Arrow />
										</div>
									</a>
								</div>
							</CarouselItem>
							<CarouselItem>
								<div class="demo-carousel">
									<div class="home-home1-content1">
										<img class="sy_bannr_q" src="../assets/img/imgs/q.png" />
										<img class="sy_bannr_1" src="../assets/img/imgs/1.png" />
										<img class="sy_bannr_2" src="../assets/img/imgs/2.png" />
										<img class="sy_bannr_3" src="../assets/img/imgs/3.png" />
										<img class="sy_bannr_4" src="../assets/img/imgs/4.png" />
										<img class="sy_bannr_5" src="../assets/img/imgs/5.png" />
										<img class="sy_bannr_6" src="../assets/img/imgs/6.png" />
										<img class="sy_bannr_7" src="../assets/img/imgs/7.png" />
										<img class="sy_bannr_8" src="../assets/img/imgs/8.png" />
										<img class="sy_bannr_9" src="../assets/img/imgs/9.png" />
										<img class="sy_bannr_10" src="../assets/img/imgs/10.png" />
										<img class="sy_bannr_11" src="../assets/img/imgs/11.png" />
										<img class="sy_bannr_12" src="../assets/img/imgs/12.png" />
										<img class="sy_bannr_sd" src="../assets/img/imgs/sd.png" />
										<img class="sy_bannr_hxcp" src="../assets/img/imgs/hxcp.png" />
										<img class="sy_bannr_jcst" src="../assets/img/imgs/jcst.png"/>
										<img class="sy_bannr_znhgc" src="../assets/img/imgs/znhgc.png" />
										<img class="sy_bannr_z" src="../assets/img/imgs/z930.png" />
										<div class="solution_classification1">
											<span>智慧校园</span>
										</div>
										<router-link :to="{path:'minimalistSolution',query:{num:'2'}}">
											<div class="solution_classification2">
												<span>智慧园区</span>
											</div>
										</router-link>
										<div class="solution_classification3">
											<span>智慧城管</span>
										</div>
										<div class="solution_classification4">
											<span>智慧工厂</span>
										</div>
										<div class="solution_classification5">
											<span>智慧物流</span>
										</div>
										<div class="solution_classification6">
											<span>智慧社区</span>
										</div>
										<a href="#twoPage">
											<div style="margin-top: 0.5rem;">
												<Arrow />
											</div>
										</a>
									</div>
								</div>
							</CarouselItem>
							<CarouselItem>
								<div class="demo-carousel">
									<img src="../assets/img/home1-bg6-content.png" width="100%"
										style="margin-top: -1rem;" />
									<a href="#twoPage">
										<div style="margin-top: -0.7rem;">
											<Arrow />
										</div>
									</a>
								</div>
							</CarouselItem>
						</Carousel>
					</div>
				</template>
			</div>
			<a name="twoPage"></a>
			<div class="my-home-content my-home2">
				<div class="a1"></div>
				<HomeContent2 />
			</div>
			<div class="my-home-content my-home3">
				<div class="left-top">
					<canvas id="root7" width="500" height="150"></canvas>
				</div>
				<div class="left-center">
					<canvas id="root1" width="300" height="400"></canvas>
				</div>
				<div class="left-bottom">
					<canvas id="root8" width="200" height="250"></canvas>
				</div>
				<div class="right-bottom">
					<canvas id="root9" width="600" height="100"></canvas>
				</div>
				<div class="right-center">
					<canvas id="root2" width="300" height="600"></canvas>
				</div>
				<HomeContent3 />
			</div>
			<div>
				<a name="fourPage"></a>
			</div>
			<div class="my-home-content my-home4">
				<HomeContent4 />
			</div>
			<div class="my-home-content my-home5">
				<HomeContent5 />
			</div>
		</div>
	</div>
</template>


<script>
	function CanvasAnimate(Dom, options) {
		options = options || {}
		this.Element = Dom
		this.cvs = Dom.getContext("2d")
		this.off_cvs = document.createElement("canvas")
		this.off_cvs.width = Dom.width
		this.off_cvs.height = Dom.height
		this.Dom = this.off_cvs.getContext("2d")
		this.width = Dom.width
		this.height = Dom.height
		this.length = options.length || 100
		this.RoundColor = options.RoundColor || "#33fff6"
		this.RoundDiameter = options.RoundDiameter || 2
		this.LineColor = options.LineColor || "#246ea3"
		this.LineWeight = options.LineWeight || 1
		this.clicked = options.clicked || false
		this.moveon = options.moveon || false
		this.list = []
		this.paused = true
	}
	CanvasAnimate.prototype.Run = function() {
		if (this.clicked) {
			this.Element.addEventListener("click", this.Clicked.bind(this))
		}
		if (this.moveon) {
			this.Element.addEventListener("mousemove", this.moveXY.bind(this))
			this.Element.addEventListener("mouseout", this.moveoutXY.bind(this))
		}
		this.Draw(this.getLength())
	}
	CanvasAnimate.prototype.getLength = function() {
		let arr = []
		for (let i = 0; i < this.length; i++) {
			let obj = {}
			obj.x = parseInt(Math.random() * this.width)
			obj.y = parseInt(Math.random() * this.height)
			obj.r = parseInt(Math.random() * 4) <= 2 ? 3 : parseInt(Math.random() * 4)
			obj.controlX = parseInt(Math.random() * 10) > 5 ? "left" : "right"
			obj.controlY = parseInt(Math.random() * 10) > 5 ? "bottom" : "top"
			arr.push(obj)
		}
		return arr
	}
	CanvasAnimate.prototype.Draw = function(list) {
		let new_arr = []
		let line_arr = []

		list.map((item, index) => {
			let xy = this.ControlXY(item)
			let obj = this.ControlRound(xy)
			new_arr.push(obj)
		});

		new_arr.map((item1, index1) => {
			new_arr.map((item2, index2) => {
				if (item1 !== item2) {
					let x = item1.x - item2.x
					let y = item1.y - item2.y
					if (Math.abs(x) < 100 && Math.abs(y) < 100) {
						let obj = {
							x1: item1.x,
							y1: item1.y,
							x2: item2.x,
							y2: item2.y,
						}
						line_arr.push(obj)
					}
				}
			})
		})

		this.drawLine(line_arr)

		new_arr.map((item) => {
			this.drawRound(item)
		})

		this.list = new_arr

		this.cvs.drawImage(this.off_cvs, 0, 0, this.width, this.height)

		setTimeout(() => {
			if (this.paused) {
				this.next()
			}
		}, 50)
	}
	CanvasAnimate.prototype.next = function() {
		this.cvs.clearRect(0, 0, this.width, this.height)
		this.Dom.clearRect(0, 0, this.width, this.height)
		this.Draw(this.list)
	}
	CanvasAnimate.prototype.drawRound = function(obj) {
		let {
			x,
			y,
			r
		} = obj
		this.Dom.beginPath()
		this.Dom.arc(x, y, r, 0, 2 * Math.PI)
		this.Dom.fillStyle = this.RoundColor
		this.Dom.shadowBlur = 10;
		this.Dom.shadowOffsetX = 1;
		this.Dom.shadowOffsetY = 1;
		this.Dom.shadowColor = "#33fff6";

		this.Dom.stroke();
		this.Dom.fill()
		this.Dom.closePath()
	}
	CanvasAnimate.prototype.drawLine = function(list) {
		list.map((item) => {
			this.Dom.beginPath()
			this.Dom.moveTo(item.x1, item.y1)
			this.Dom.lineTo(item.x2, item.y2)
			this.Dom.lineWidth = this.LineWeight
			this.Dom.strokeStyle = this.LineColor
			this.Dom.shadowBlur = '';
			this.Dom.shadowOffsetX = 0;
			this.Dom.shadowOffsetY = 0;
			this.Dom.shadowColor = "";
			this.Dom.stroke()
			this.Dom.closePath()
		})
	}
	CanvasAnimate.prototype.ControlXY = function(obj) {
		if (obj.x >= (this.width - obj.r)) {
			obj.controlX = 'left'
		} else if (obj.x <= parseInt(obj.r / 2)) {
			obj.controlX = "right"
		}

		if (obj.y >= (this.height - obj.r)) {
			obj.controlY = "bottom"
		} else if (obj.y <= parseInt(obj.r / 2)) {
			obj.controlY = "top"
		}
		return obj
	}
	CanvasAnimate.prototype.ControlRound = function(obj) {
		switch (obj.controlX) {
			case "right":
				obj.x++;
				break;
			case "left":
				obj.x--;
				break;
		}
		switch (obj.controlY) {
			case "top":
				obj.y++;
				break;
			case "bottom":
				obj.y--;
				break;
		}
		return obj
	}
	CanvasAnimate.prototype.Clicked = function(event) {
		let obj = {}
		obj.x = event.clientX
		obj.y = event.clientY
		obj.r = parseInt(Math.random() * 4) <= 2 ? 3 : parseInt(Math.random() * 4)
		obj.controlX = parseInt(Math.random() * 10) > 5 ? 'left' : 'right'
		obj.controlY = parseInt(Math.random() * 10) > 5 ? 'bottom' : 'top'
		this.list.push(obj)
	}
	CanvasAnimate.prototype.moveXY = function(event) {
		let obj = {}
		obj.x = event.clientX
		obj.y = event.clientY
		obj.r = 0
		obj.move = true
		if (this.list[0]["move"]) {
			this.list[0]["x"] = obj.x
			this.list[0]["y"] = obj.y
			this.list[0]["r"] = 1
		} else {
			this.list.unshift(obj)
		}
	}
	CanvasAnimate.prototype.moveoutXY = function(event) {
		this.list.shift()
	}
	CanvasAnimate.prototype.pause = function() {
		this.paused = !this.paused
		if (this.paused) {
			this.Draw(this.list)
		}
	}

	import HomeContent1 from '@/pages/home-content/HomeContent1.vue'
	import HomeContent2 from '@/pages/home-content/HomeContent2.vue'
	import HomeContent3 from '@/pages/home-content/HomeContent3.vue'
	import HomeContent4 from '@/pages/home-content/HomeContent4.vue'
	import HomeContent5 from '@/pages/home-content/HomeContent5.vue'
	import Arrow from '@/pages/components/Arrow'
	export default {
		name: 'Home',
		components: {
			HomeContent1,
			HomeContent2,
			HomeContent3,
			HomeContent4,
			HomeContent5,
			Arrow
		},
		data() {
			return {
				btnFlag: false
			}
		},
		mounted() {
			this.qd()
		},
		methods: {
			qd() {
				var root1 = document.querySelector("#root1")
				var root2 = document.querySelector("#root2")
				var root3 = document.querySelector("#root7")
				var root4 = document.querySelector("#root8")
				var root5 = document.querySelector("#root9")
				var a = new CanvasAnimate(root1, {
					length: 20,
					clicked: true,
					moveon: true
				})
				var b = new CanvasAnimate(root2, {
					length: 40,
					clicked: true,
					moveon: true
				})
				var c = new CanvasAnimate(root3, {
					length: 20,
					clicked: true,
					moveon: true
				})
				var d = new CanvasAnimate(root4, {
					length: 10,
					clicked: true,
					moveon: true
				})
				var e = new CanvasAnimate(root5, {
					length: 20,
					clicked: true,
					moveon: true
				})
				a.Run()
				b.Run()
				c.Run()
				d.Run()
				e.Run()
			},

		},

	}
</script>

<style>
	@keyframes q {
		0% {
			-webkit-transform: rotate(0deg);
		}

		25% {
			-webkit-transform: rotate(90deg);
		}

		50% {
			-webkit-transform: rotate(180deg);
		}

		75% {
			-webkit-transform: rotate(270deg);
		}

		100% {
			-webkit-transform: rotate(360deg);
		}
	}

	@keyframes num {
		0% {
			opacity: 0;
		}

		50% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}

	@keyframes num1 {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}

	@keyframes num2 {
		0% {
			opacity: 0;
		}

		50% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}

	@keyframes num3 {
		0% {
			opacity: 0;
		}

		20% {
			opacity: 0;
		}

		40% {
			opacity: 1;
		}

		60% {
			opacity: 0;
		}

		100% {
			opacity: 0;
		}
	}

	@keyframes num4 {
		0% {
			opacity: 0;
		}

		40% {
			opacity: 0;
		}

		60% {
			opacity: 1;
		}

		80% {
			opacity: 0;
		}

		100% {
			opacity: 0;
		}
	}

	@keyframes num5 {
		0% {
			opacity: 0;
		}

		40% {
			opacity: 0;
		}

		60% {
			opacity: 0;
		}

		80% {
			opacity: 1;
		}

		100% {
			opacity: 0;
		}
	}

	.sy_bannr_q {
		animation: q 10s linear infinite;
		position: absolute;
		width: 38%;
		left: 49.5%;
		top: 6.5%;
	}

	.sy_bannr_1 {
		position: absolute;
		width: 38%;
		left: 49.5%;
		top: 71.5%;
		animation: num 1s linear infinite;
		/* animation-delay:15s;  */
	}

	.sy_bannr_2 {
		position: absolute;
		width: 38%;
		left: 49.5%;
		top: 71.5%;
		animation: num 2s linear infinite;
		/* animation-delay:14s; */
	}

	.sy_bannr_3 {
		position: absolute;
		width: 38%;
		left: 49.5%;
		top: 71.5%;
		animation: num 3s linear infinite;
		/* animation-delay:13s; */
	}

	.sy_bannr_4 {
		position: absolute;
		width: 38%;
		left: 49.5%;
		top: 71.5%;
		animation: num 4s linear infinite;
		/* animation-delay:12s;  */
	}

	.sy_bannr_5 {
		position: absolute;
		width: 38%;
		left: 49.5%;
		top: 71.5%;
		animation: num 5s linear infinite;
		/* animation-delay:11s;  */
	}

	.sy_bannr_6 {
		position: absolute;
		width: 38%;
		left: 49.5%;
		top: 71.5%;
		animation: num 6s linear infinite;
		/* animation-delay:10s; */
	}

	.sy_bannr_7 {
		position: absolute;
		width: 38%;
		left: 49.5%;
		top: 71.5%;
		animation: num 7s linear infinite;
		/* animation-delay:9s;  */
	}

	.sy_bannr_8 {
		position: absolute;
		width: 38%;
		left: 49.5%;
		top: 71.5%;
		animation: num 8s linear infinite;
		/* animation-delay:8s; */
	}

	.sy_bannr_9 {
		position: absolute;
		width: 38%;
		left: 49.5%;
		top: 71.5%;
		animation: num 9s linear infinite;
		/* animation-delay:7s; */
	}

	.sy_bannr_10 {
		position: absolute;
		width: 43%;
		left: 46.5%;
		top: 70.5%;
		animation: num 10s linear infinite;
		/* animation-delay:6s; */
	}

	.sy_bannr_11 {
		position: absolute;
		width: 43%;
		left: 46.5%;
		top: 25.5%;
		animation: num 11s linear infinite;
		/* animation-delay:5s; */
	}

	.sy_bannr_12 {
		position: absolute;
		width: 43%;
		left: 47.5%;
		top: 10.5%;
		animation: num 12s linear infinite;
		/* animation-delay:4s; */
	}

	.sy_bannr_sd {
		position: absolute;
		width: 13%;
		left: 62.5%;
		top: 60.5%;
		animation: num 13s linear infinite;
		/* animation-delay:3s;  */
	}

	.sy_bannr_z {
		position: absolute;
		left: 49%;
		width: 41%;
		top: 16.5%;
		animation: num1 5s linear;
	}

	.sy_bannr_z931 {
		display: none;
		position: absolute;
		left: 37.3%;
		width: 63%;
		height: 60.5%;
		top: 14.4%;
		animation: num1 3s linear;

	}

	.sy_bannr_z932 {

		position: absolute;
		left: 36.5%;
		width: 64.5%;
		height: 59%;
		top: 15%;
		animation: num1 3s linear;
	}

	.sy_bannr_hxcp {
		position: absolute;
		left: 62%; /*62*/
		width: 13%;/*13*/
		height: 56%;/*56*/
		top: 16%;
		animation: num1 3s linear;
	}

	.sy_bannr_jcst {
		position: absolute;
		left: 66%;/*66*/
		width: 15%;/*15*/
		height: 50%;/*50*/
		top: -5.5%;/*-5.5*/
		animation: num1 3s linear;
	}

	.sy_bannr_znhgc {
		position: absolute;
		left: 57%;
		width: 22%;
		top: 45%;
		animation: num1 3s linear;
	}

	.sy_bannr_zh1 {
		opacity: 0;
		position: absolute;
		left: 56.3%;
		width: 5.6%;
		top: 23.5%;
		animation: num2 1s linear infinite;
		animation-delay: 5s;
	}

	.sy_bannr_zh1_div {
		opacity: 0;
		position: absolute;
		left: 56.3%;
		width: 5.6%;
		height: 5%;
		top: 23.5%;
		border-radius: 50%;
		box-shadow: 0px 0px 30px rgb(0 217 255);
		animation: num2 1s linear infinite;
		animation-delay: 5s;
	}

	.sy_bannr_zh2 {
		opacity: 0;
		position: absolute;
		left: 49.5%;
		width: 5.9%;
		top: 32.7%;
		animation: num2 1s linear infinite;
		animation-delay: 6s;
	}

	.sy_bannr_zh2_div {
		opacity: 0;
		position: absolute;
		left: 49.5%;
		width: 5.9%;
		height: 5.5%;
		top: 32.7%;
		border-radius: 50%;
		box-shadow: 0px 0px 30px rgb(0 217 255);
		animation: num2 1s linear infinite;
		animation-delay: 6s;
	}

	.sy_bannr_zh3 {
		opacity: 0;
		position: absolute;
		left: 51.2%;
		width: 6%;
		top: 48.6%;
		animation: num2 1s linear infinite;
		animation-delay: 7s;
	}

	.sy_bannr_zh3_div {
		opacity: 0;
		position: absolute;
		left: 51.2%;
		width: 6%;
		height: 5.8%;
		top: 48.6%;
		border-radius: 50%;
		box-shadow: 0px 0px 30px rgb(0 217 255);
		animation: num2 1s linear infinite;
		animation-delay: 7s;
	}

	.sy_bannr_zh4 {
		opacity: 0;
		position: absolute;
		left: 78.4%;
		width: 6%;
		top: 61.1%;
		animation: num2 1s linear infinite;
		animation-delay: 8s;
	}

	.sy_bannr_zh4_div {
		opacity: 0;
		position: absolute;
		left: 78.4%;
		width: 6%;
		height: 5.8%;
		top: 61.1%;
		border-radius: 50%;
		box-shadow: 0px 0px 30px rgb(0 217 255);
		animation: num2 1s linear infinite;
		animation-delay: 8s;
	}

	.sy_bannr_zh5 {
		opacity: 0;
		position: absolute;
		left: 78.6%;
		width: 5.9%;
		top: 49.3%;
		animation: num2 1s linear infinite;
		animation-delay: 9s;
	}

	.sy_bannr_zh5_div {
		opacity: 0;
		position: absolute;
		left: 78.6%;
		width: 5.9%;
		height: 5.5%;
		top: 49.3%;
		border-radius: 50%;
		box-shadow: 0px 0px 30px rgb(0 217 255);
		animation: num2 1s linear infinite;
		animation-delay: 9s;
	}

	.sy_bannr_zh6 {
		opacity: 0;
		position: absolute;
		left: 78.4%;
		width: 5.6%;
		top: 36%;
		animation: num2 1s linear infinite;
		animation-delay: 10s;
	}

	.sy_bannr_zh6_div {
		opacity: 0;
		position: absolute;
		left: 78.4%;
		width: 5.6%;
		height: 5%;
		top: 36%;
		border-radius: 50%;
		box-shadow: 0px 0px 30px rgb(0 217 255);
		animation: num2 1s linear infinite;
		animation-delay: 10s;
	}

	.solution_classification1 {
		position: absolute;
		left: 52%;
		top: 18.5%;
		font-size: 0.2rem;
		color: #09b5d3;
		animation: num1 3s linear;
	}

	.solution_classification2 {
		position: absolute;
		left: 44.5%;
		top: 29.5%;
		font-size: 0.2rem;
		color: #09b5d3;
		animation: num1 3s linear;
	}

	.solution_classification3 {
		position: absolute;
		left: 46.5%;
		top: 48%;
		font-size: 0.2rem;
		color: #09b5d3;
		animation: num1 3s linear;
	}

	.solution_classification4 {
		position: absolute;
		left: 86.5%;
		top: 33.3%;
		font-size: 0.2rem;
		color: #09b5d3;
		animation: num1 3s linear;
	}

	.solution_classification5 {
		position: absolute;
		left: 90.2%;
		top: 48.5%;
		font-size: 0.2rem;
		color: #09b5d3;
		animation: num1 3s linear;
	}

	.solution_classification6 {
		position: absolute;
		left: 87.1%;
		top: 63.2%;
		font-size: 0.2rem;
		color: #09b5d3;
		animation: num1 3s linear;
	}

	.sy_bannr_111 {
		position: absolute;
		left: 27.5%;
		width: 7%;
		top: 11%;
		animation: num1 3s linear;
	}

	.sy_bannr_222 {
		position: absolute;
		left: 19%;
		width: 7%;
		top: 31%;
		animation: num1 3s linear;
	}

	.sy_bannr_333 {
		position: absolute;
		left: 21.3%;
		width: 7%;
		top: 52%;
		animation: num1 3s linear;
	}

	.sy_bannr_444 {
		position: absolute;
		left: 65.5%;
		width: 7%;
		top: 26.7%;
		animation: num1 3s linear;
	}

	.sy_bannr_555 {
		position: absolute;
		left: 70%;
		width: 7%;
		top: 44%;
		animation: num1 3s linear;
	}

	.sy_bannr_666 {
		position: absolute;
		left: 66%;
		width: 7%;
		top: 68%;
		animation: num1 3s linear;
	}

	.my-home-content {
		height: 80%;
		padding-top: 1rem;
	}

	.home {
		width: 100%;
		background-color: #FFFFFF;
	}

	/*    .home1{
      background-size: 100% 30%;
      background-image: url(../assets/img/bg1.png);
      background-repeat: no-repeat;
    } */
	.my-home3 {
		overflow: hidden;
		position: relative;
		/* height: 9.3rem; */
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-image: url(../assets/img/bg3-1.png);
	}

	.left-top {
		position: absolute;
		left: -110px;
		top: -60px;
	}

	.left-center {
		position: absolute;
		left: -110px;
		top: -40px;
	}

	.left-bottom {
		position: absolute;
		left: -110px;
		top: 150px;
	}

	.right-center {
		overflow: hidden;
		width: 3rem;
		height: 5rem;
		position: absolute;
		right: 0;
		bottom: 0;
	}

	.right-bottom {
		overflow: hidden;
		width: 6rem;
		height: 1rem;
		position: absolute;
		right: 0;
		bottom: 0;
	}

	.my-home4 {
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-image: url(../assets/img/home-conten4-bg.png);
	}

	.my-home5 {
		background-repeat: no-repeat;
		background-size: 100% 100%;

		background-image: url(../assets/img/home-content5-bg.jpg);
	}

	.my-home2 {
		padding-bottom: 1rem;
		position: relative;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-image: url(../assets/img/home2-bg1.jpg);
	}

	.a1 {
		width: 7rem;
		height: 1rem;
		background-color: #FFFFFF;
		position: absolute;
		left: 0;
		bottom: 0;
		z-index: 1;
	}


	.content-word-1 {
		margin-top: 0.65rem;
		width: 50%;
		float: left;

	}

	.content-word-1 h2 {
		color: #FFFFFF;
		font-size: 0.4rem;
		margin-bottom: 0.25rem;
		letter-spacing: 0.05rem;
	}

	.content-word-1 p {
		color: #ffffff;
		font-size: 0.1rem;
	}

	.content-img-1 {
		width: 50%;
		float: left;
		padding-right: 1rem;
	}

	.content-icon-1 {
		margin-top: 0.5rem;
		margin-bottom: 0.75rem;
	}

	.icon {
		float: left;
		text-align: center;
	}

	.icon1,
	.icon2 {
		margin-right: 0.25rem;
	}

	.content-img-1 {
		position: relative;
	}

	.home-home1-content1 {
		position: relative;
		height: 10rem;
		background-size: 100% 100%;
		/* background-image: url(../assets/img/imgs/bnee.jpg); */
		background-image: url(../assets/img/home1-bg4.png);
		/* background-repeat: no-repeat; */
		padding-top: 9rem;
	}

	.home-home1-content2 {
		height: 10rem;
		background-image: url(../assets/img/home1-bg2.jpg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.home-home1-content3 {
		height: 10rem;
		background-image: url(../assets/img/home1-bg3.jpg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.home-home1-content4 {
		height: 10rem;
		background-image: url(../assets/img/home1-bg4.jpg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
	}

	.my-home1 .ivu-carousel-dots-inside {
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue